
/* START_TEMPLATE */
define('hbs!app/templates/errors',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "<div class=\"at-alert at-error\" tabindex=\"-1\">"
    + escapeExpression(lambda(depth0, depth0))
    + "<a class=\"at-dismiss\" href=\"#\">&times;</a></div>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = helpers.each.call(depth0, (depth0 != null ? depth0.messages : depth0), {"name":"each","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
}});
Handlebars.registerPartial('app/templates/errors', t);
return t;
});
/* END_TEMPLATE */
;
